import { styled, Button } from '@mui/material';
import styledComponent from 'styled-components';

type ButtonProps = {
  children: string;
  fullWidth?: boolean;
  paddingY?: number;
  paddingX?: number;
};

const CommonButton = styled(Button)(() => ({
  borderRadius: 15,
  background: 'var(--Accent-Deep-Koamaru, #2A3C67)',
  color: 'var(--Accent-White, #FFF) !important',
  '&:hover': {
    background: 'var(--Accent-Deep-Koamaru, #2A3C67)',
  },
}));

const StyledDiv = styledComponent.div`
    width: 21px;
    height: 21px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 3px solid;
    border-color: #2A3C67 #fff;
    animation: l1 1s infinite;
    @keyframes l1 {to{transform: rotate(.5turn)}}
`;

function LoadingButton({ children, fullWidth, paddingY, paddingX }: ButtonProps) {
  return (
    <CommonButton
      type="submit"
      color="primary"
      variant="contained"
      fullWidth={fullWidth}
      startIcon={<StyledDiv />}
      sx={{
        textTransform: 'none !important',
        padding: `${paddingY}px ${paddingX}px !important`,
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </CommonButton>
  );
}

LoadingButton.defaultProps = {
  paddingX: 32,
  paddingY: 16,
};

export default LoadingButton;
